// src/components/VersionHistoryModal.js

import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const formatDate = (timestamp) => {
  if (!timestamp) {
    return 'Date not available';
  }
  // Supabase returns standard ISO date strings, so we can just pass it to the Date constructor
  return new Date(timestamp).toLocaleString();
};

export const VersionHistoryModal = ({ isOpen, onRequestClose, versions, onPromote, fileName, latestVersionId }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Version History Modal"
      className="modal"
      overlayClassName="overlay"
    >
      <button className="modal-close-btn" onClick={onRequestClose} aria-label="Close version history">&times;</button>
      <h2>Version History for "{fileName}"</h2>
      
      <div style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: '8px' }}>
        {versions && versions.length > 0 ? (
          <ul className="version-history-list">
            {versions.map((version, index) => {
              const isLatest = version.id === latestVersionId;
              const versionNumber = versions.length - index;

              return (
                <li key={version.id} className={`version-history-item ${isLatest ? 'latest' : ''}`}>
                  <div>
                    <strong>Version {versionNumber}</strong> 
                    {isLatest && <span className="version-history-latest-badge">Latest</span>}
                    <br />
                    <small>Uploaded: {formatDate(version.uploadedAt)}</small>
                  </div>
                  <div className="file-actions" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <a href={version.fileUrl} target="_blank" rel="noopener noreferrer" download className="share-button" style={{ textDecoration: 'none' }}>Download</a>
                    {!isLatest && (
                      <button 
                        onClick={() => onPromote(version)} 
                        className="action-button save-button"
                        style={{ margin: 0 }}
                      >
                        Make Current
                      </button>
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
          <p style={{ textAlign: 'center', color: 'var(--color-text-secondary)', margin: '20px 0' }}>Loading version history...</p>
        )}
      </div>

    </Modal>
  );
};